import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Button from "../Button";
// import { ReactComponent as ArrowBack } from "../../assets/svg/arrow-back.svg";
import VideoPlay from "../VideoPlay";
import ModalForm from "./ModalForm";
// import Checkout from "./FormCheckout";
import { useCourses } from "../../hooks/useCourses";
import ListTitles from "../ListTitles";
import { useEpisodes } from "../../hooks/useEpisodes";
// import FormGeneralData from "./FormGeneralData";
import FormMain from "./FormMain";
import { useParams } from "react-router-dom";
import { getCheckoutPageById } from "../../apis/Admin";

const Course = ({ courseId = "198686e6-3034-11ec-8d3d-0242ac130003" }) => {
  let { checkoutPageId } = useParams();

  const [checkoutPage, setCheckoutPage] = useState(undefined);

  const [showCheckout, setShowCheckout] = useState(false);

  const { courses } = useCourses();
  const episodesFull = useEpisodes();

  useEffect(() => {
    if (checkoutPageId !== undefined && typeof checkoutPageId === "string") {
      const unsubscribe = getCheckoutPageById(checkoutPageId, (data) => {
        setCheckoutPage(data);
      });

      return () => unsubscribe();
    }
  }, [checkoutPageId]);

  const course = useMemo(() => {
    return courses?.find((course) => course.id === courseId);
  }, [courseId, courses]);

  const episodes = useMemo(() => {
    if (course === undefined || !course?.episodes || !episodesFull) return [];

    return episodesFull
      .filter((episode) => course.episodes.includes(episode.id))
      .map((episode) => ({
        ...episode,
        purchased: undefined,
        free: undefined,
        completed: false,
      }));
  }, [episodesFull, course]);

  return (
    <>
      <ContainerWrapper>
        <Container>
          <Wrapper>
            <TitleWrapper>
              <Title>{course?.title}</Title>
            </TitleWrapper>
            {checkoutPage?.videoPromotionURL !== undefined &&
              checkoutPage?.priceTotal !== undefined && (
                <>
                  <VideoPlay url={checkoutPage?.videoPromotionURL} />
                  <ButtonStyled
                    primary={true}
                    text={`Tengo cupón y pago $${
                      (
                        checkoutPage?.priceTotal -
                        checkoutPage?.priceTotal *
                          ((checkoutPage?.discountPercentage || 0) / 100)
                      ).toFixed(2) || ""
                    }`}
                    onClick={() => setShowCheckout(true)}
                  />
                  <ButtonStyled
                    primary={true}
                    text={`Adquirir curso de $${
                      checkoutPage?.priceTotal?.toFixed(2) || ""
                    }`}
                    onClick={() => setShowCheckout(true)}
                  />
                </>
              )}
            <ListTitles allowAll={true} items={episodes} noOpacity={true} />
          </Wrapper>
        </Container>
      </ContainerWrapper>
      <ModalForm isOpen={showCheckout} onClose={() => setShowCheckout(false)}>
        <FormMain
          price={checkoutPage?.priceTotal}
          discountPercentage={checkoutPage?.discountPercentage || 0}
          courseId={courseId}
          onClose={() => setShowCheckout(false)}
        />
      </ModalForm>
    </>
  );
};

const ContainerWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #32b0ea;
  padding: 10px;
  box-sizing: border-box;
`;

const Container = styled.div`
  max-width: 450px;
  width: 100%;
`;

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

const ButtonStyled = styled(Button)`
  margin: 25px 0px;
  .button {
    background-color: #226dd4;
    padding: 20px;
  }
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 0px;
  margin-bottom: 25px;

  user-select: none;
`;

const Back = styled.div`
  fill: white;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin-right: 15px;
`;

const Title = styled.div`
  font-size: 1.5em;
  font-weight: 600;
  color: white;
`;

export default Course;
